import styled from 'styled-components/macro';

export const StyledSplashScreen = styled.div`
  padding: 40px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .spinner-grow {
    width: 3rem;
    height: 3rem;
    color: ${(props) => props.theme.purple};
  }
  .spinner-border {
    color: ${(props) => props.theme.purple};
  }
`;
